import {
  Card,
  Icon,
  Row,
  Col,
  Input,
  Button,
} from "antd";
import { ChangeEvent, createElement, KeyboardEvent, Props as ReactProps } from "react";
import styled from 'styled-components';
import Product from "../../../../entity/product";
import Text from '../../atoms/Text';
import Image from '../../atoms/Image';
import {
  BASE_BORDER_COLOR,
} from '../../../constants/color';
import PageInfo from "../../../../entity/pageInfo";
import * as InfiniteScroll from 'react-infinite-scroller';
import { OrderProductType } from '../../../../state/contentSelect';
import OrderProduct from "../../../../entity/orderProduct";

type Props = ReactProps<HTMLSpanElement> & {
  products: Product[];
  orderProducts: OrderProductType;
  updateOrderProductField: (orderProduct: OrderProduct, count: number) => void;
  productNextPage: () => Promise<PageInfo>;
  productPageInfo: PageInfo;
};

const InputGroup = Input.Group;

const StyledContentLayout = styled.div`
  overflow: auto;
  height: auto;
`;

const StyledCard = styled(Card)`
  margin: 10px !important;
  padding: 20px;
  width: 280px;
  border-radius: 10px !important;
  flex-shrink: 0;
`;

const StyledCardImg = styled(Image)<{ alt: string }>`
  height: 160px;
  img {
    padding: 10px;
  }
`;

const StyledTitleItem = styled(Text)`
  display: block;
`;

const StyledItemNumContainer = styled(Row)`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 10px;
`;

const StyledItemNumWrapper = styled(Col)`
  display: inline-block;
`;

const StyledCardContent = styled.div`
  min-height: 70px;
  border-bottom: 1px solid ${BASE_BORDER_COLOR};
`;

const StyledIconCountContent = styled(Icon)`
  svg {
    margin-top: -7px;
  }
`;

const StyledInfiniteScroll = styled(InfiniteScroll)`
  width: 100%;
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  align-items: start;
  flex-wrap: wrap;
`;

const ContentSelectForm = (props: Props) => {
  const {
    orderProducts,
    updateOrderProductField,
    productNextPage,
    products,
    productPageInfo,
  } = props;
  const setOrderProduct = (orderProduct: OrderProduct, count: number) => {
    if (count >= 0 && orderProduct) {
      updateOrderProductField(orderProduct, count);
    }
  };
  const onKeyPress = (e: KeyboardEvent<HTMLInputElement>, orderProduct: OrderProduct, count: number) => {
    const key = 'Backspace';
    if (count < 10 && e.key === key) {
      setOrderProduct(orderProduct, 0);
    }
  };

  const ContentItems = products.map((product: Product) => {
    const orderProduct = orderProducts.get(product.id) || OrderProduct.fromProduct(product);
    const productCount = orderProduct.count || 0;
    return (
      <StyledCard
        cover={<StyledCardImg alt={product.displayTitle()} src={product.displayImage()} />}
        key={`select-content-${product.id}`}
      >
        <StyledCardContent>
          <StyledTitleItem>
            {product.displayTitle()}
          </StyledTitleItem>
          <StyledTitleItem bold={true}>
            ¥{product.price + product.taxPrice}
          </StyledTitleItem>
        </StyledCardContent>
        <StyledItemNumContainer type="flex" justify="center" align="middle">
          <StyledItemNumWrapper>
            <InputGroup compact={true} style={{ display: 'inline-block' }}>
              <Button onClick={() => setOrderProduct(orderProduct, productCount - 1)}>
                <StyledIconCountContent type="minus" />
              </Button>
              <Input
                min={0}
                type="number"
                onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => onKeyPress(e, orderProduct, productCount)}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setOrderProduct(orderProduct, parseInt(e.target.value))}
                value={productCount}
                style={{ width: 70 }}
              />
              <Button onClick={() => setOrderProduct(orderProduct, productCount + 1)}>
                <StyledIconCountContent type="plus" />
              </Button>
            </InputGroup>
          </StyledItemNumWrapper>
        </StyledItemNumContainer>
      </StyledCard>
    )
  });

  return (
    <StyledContentLayout>
      <StyledInfiniteScroll
        initialLoad={false}
        pageStart={0}
        loadMore={productNextPage}
        hasMore={productPageInfo.hasNextPage}
        useWindow={false}
      >
        {ContentItems}
      </StyledInfiniteScroll>
      {
        productPageInfo.hasNextPage &&
        <Button type="link" block={true} onClick={productNextPage}>
          さらに読み込む
        </Button>
      }
    </StyledContentLayout>
  );
};

export default ContentSelectForm;
